























































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import { setCookie, getCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
const QRcode = require("qrcodejs2");
import previewComponent from "./previewComponent.vue"; //预览模板
import httpApi from "@/API/Tenant/Weixin";

@Component({
  components: {
    QRcode,
    previewComponent
  }
})
export default class extends Vue {
  @Prop() private propFormList!: any;
  @Prop() private searchpropFormList!: any;
  @Provide() activeName: string = "listForm"; //当前选中tab的name
  @Provide() formDialogVisible: boolean = false;
  @Provide() formPreviewDialogVisible: boolean = false;
  @Provide() userFormPreviewDialogVisible: boolean = false;
  @Provide() modifyStatusVisible: boolean = false;
  @Provide() viewListVisible: boolean = false;
  @Provide() searchKeyword: any = null;
  @Provide() previewI: number = 0;
  @Provide() sysTemplateTypeList: any = ["节日", "简约", "促销", "其他"];
  @Provide() currentSysTempType: string = "全部";
  @Provide() defaultFormList: any = [];
  @Provide() currentPreviewForm: any = "";
  @Provide() modelTemplateTitle = "新建空白表单";
  @Provide() pagesize: number = 10;
  @Provide() currentPage: number = 1;
  @Provide() tenantID: any = 1;
  @Provide() statusVal: any = { value: "2", label: "收集中" };
  @Provide() statusList: any = [
    { value: "1", label: "停止收集" },
    { value: "2", label: "收集中" }
  ];
  //收集数据相关
  @Provide() elTableColumn: any = [];
  @Provide() tableData: any = [];
  @Provide() totalTow: number = 0;
  @Provide() currentPageTow: number = 1;
  @Provide() pagesizeTow: number = 10;
  //初始化
  async created() {
    this.tenantID = getCookie("TenantID");
    if (getCookie("TenantID") == "0") {
      this.modelTemplateTitle = "新建模板数据";
      this.statusList = [
        { value: "1", label: "停用" },
        { value: "2", label: "启用" }
      ];
    }
    this.loadModelList();
    this.GetSmartTypeList();
  }
  shuaxin() {
    this.loadModelList();
    this.$message.success("刷新成功！");
  }
  //加载模板数据
  async loadModelList() {
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: { TenantID: 0 }
        }
      ]
    };
    var res: any = await httpApi.GetSmartFormMainListAsync(params);
     console.log(res);
    var _this = this;
    // console.log(_this.searchKeyword);

    if (res.ErrorCode == 0) {
      var result = res.output[0].value;
      this.defaultFormList = result;
    } else {
      this.$message.error("取列表失败：" + res.ErrorMessage);
    }
  }
  // 选择系统模板类型
  checkTemplateType(tempData: string) {
    this.currentSysTempType = tempData;
  }
  /** 模板表单预览 */
  PreviewSysForm(index: any) {
    var _this = this;
    _this.previewI = index;
    _this.previewI == _this.defaultFormList.length - 1 ? false : true;
    _this.formPreviewDialogVisible = true;
    _this.currentPreviewForm = _this.defaultFormList[index];
    this.$nextTick(() => {
      this.qrcodeinit();
    });
  }
  //查询模板分类列表
  async GetSmartTypeList() {
    let params: any = {
      Input: []
    };
    // console.log(params);
    //this.loading = true;
    this.sysTemplateTypeList = [];
    var res: any = await httpApi.GetSmartTypeList(params);
    //this.loading = false; //sysTemplateTypeOptions
    // console.log(res);
    if (res.ErrorCode == 0) {
      this.sysTemplateTypeList = res.output[0].value;
    } else {
      this.$message.error("失败：" + res.ErrorMessage);
    }
  }
  //预览上一个模板
  previewPrev() {
    let _this = this;
    if (_this.previewI <= 0) {
      _this.previewI = 0;
    } else {
      _this.previewI--;
      _this.currentPreviewForm = _this.defaultFormList[_this.previewI];
    }
  }
  /** 预览下一个模板 */
  previewNext() {
    let _this = this;
    let defaultTemplateCounts = _this.defaultFormList.length - 1;
    if (_this.previewI >= defaultTemplateCounts) {
      _this.previewI = defaultTemplateCounts;
    } else {
      _this.previewI++;
      _this.currentPreviewForm = _this.defaultFormList[_this.previewI];
    }
  }
  /** 二维码设置 */
  qrcodeinit() {
    let _this = this;
    let qrcode = new QRcode("qrcode", {
      width: 114, // 设置宽度，单位像素
      height: 114, // 设置高度，单位像素
      text: this.currentPreviewForm.codeUrl, // 设置二维码内容或跳转地址
      render: "div"
    });
  }
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.loadModelList();
  }
  private handleCurrentChange(val: any) {
    this.currentPage = val;
    this.loadModelList();
  }
  private handleSizeChangeTow(val: any) {
    this.pagesizeTow = val;
    this.viewList(-1, "");
  }
  private handleCurrentChangeTow(val: any) {
    this.currentPageTow = val;
    this.viewList(-1, "");
  }
  /** 清除二维码 */
  closeCode() {
    (this as any).$refs.qrcode.innerHTML = "";
  }
  /**
   * 新增或修改表单
   */
  topage(formData: any) {
    this.$emit("formData", {
      pagename: "addForm",
      pageindex: formData.pageindex,
      pageinfo: formData.pageinfo
    });
  }
  sysModuleAdd(formData: any) {
    this.$emit("sysFormData", {
      pagename: "addForm",
      pageindex: formData.pageindex,
      pageinfo: formData.pageinfo
    });
  }
  /**
   * 复制表单
   */
  async copyForm(item: any) {
    let that = this;
    let copyForm = JSON.parse(JSON.stringify(item)); // JSON.parse(JSON.stringify(that.propFormList[index])); //对象的深拷贝
    copyForm.mtitle += "-副本";
    copyForm.createTime =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate() +
      " " +
      new Date().getHours() +
      ":" +
      new Date().getMinutes() +
      ":" +
      new Date().getSeconds();
    copyForm.SmartFormId = "";
    copyForm.moduleList = JSON.stringify(copyForm.moduleList);
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: copyForm
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.SaveSmartFormMainAsync(params);
    //console.log(res);
    if (res.ErrorCode == 0) {
      this.$message.success("保存成功！");
      if (!copyForm.SmartFormId) {
        copyForm = res.output[0].value;
        copyForm.moduleList = JSON.parse(copyForm.moduleList);
        //that.propFormList.push(copyForm);
        that.$emit("LoadGetformList");
      }
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }
  //搜索数据
  searchData() {
    // console.log(this.searchpropFormList);
    var result = this.searchpropFormList;
    if (this.searchKeyword) {
      result = result.filter((item: any, index: any) =>
        item.mtitle.includes(this.searchKeyword)
      );
    } else {
      result = this.searchpropFormList;
    }
    console.log(result);
    this.propFormList = result;
  }
  /*
   *修改智能表单状态
   */
  modifyStatus(item: any) {
    // let that = this;
    // var modfiyModel = that.propFormList[index];
    this.currentPreviewForm = item; // this.propFormList[index];
    this.statusVal = {
      value: this.currentPreviewForm.statusInt + "",
      label: this.currentPreviewForm.status
    };
    // console.log(this.statusVal);
    this.modifyStatusVisible = true;
  }
  /**
   * 查看收集数据
   */
  async viewList(index: number, item: any) {
    if (index != -1) {
      this.currentPreviewForm = item; // this.propFormList[index];
    }
    this.viewListVisible = true;
    this.tableData = [];
    this.elTableColumn = [];
    //this.totalTow=0;
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.currentPreviewForm
        },
        {
          Name: "size",
          Value: this.pagesizeTow
        },
        {
          Name: "pages",
          Value: this.currentPageTow
        }
      ]
    };
    // console.log(params);
    var res: any = await httpApi.GetSmartFormSubmitListAsync(params);
    // console.log(res);
    if (res.ErrorCode == 0) {
      this.totalTow = res.output[1].value;
      let varData = res.output[0].value;
      console.log(varData[0].Item);
      //加载收集数据表头
      this.elTableColumn = varData[0].Item;
      this.elTableColumn.push({ title: "用户标识", value: "" });
      //加载内容
      varData.forEach((el: any) => {
        var data: any = [];
        el.Item.forEach((element: any) => {
          data.push(element.value);
        });
        this.tableData.push(data);
      });
    } else {
      this.$message.error("读取收集数据失败：" + res.ErrorMessage);
    }
  }
  //保存智能表单状态
  async modifyStatusSave() {
    this.currentPreviewForm.status = this.statusVal.label;
    this.currentPreviewForm.statusInt = this.statusVal.value;
    this.currentPreviewForm.getTouSuAdmin = JSON.stringify(
      this.currentPreviewForm.getTouSuAdmin
    );
    this.currentPreviewForm.moduleList = JSON.stringify(
      this.currentPreviewForm.moduleList
    );
    this.currentPreviewForm.submitTime = JSON.stringify(
      this.currentPreviewForm.submitTime
    );
    let params: any = {
      Input: [
        {
          Name: "model",
          Value: this.currentPreviewForm
        }
      ]
    };
    var res: any = await httpApi.UpdateSySmartFormStatusAsync(params);
    if (res.ErrorCode == 0) {
      this.$message.success("保存成功！");
      this.modifyStatusVisible = false;
      this.$emit("LoadGetformList");
      //this.$router.go(0);
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }
  //
  /**
   * 移除表单
   */
  removeForm(item: any) {
    let that = this;
    this.$confirm("此操作将永久删除该表单, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        var delModel = item; // that.propFormList[index];
        delModel.moduleList = JSON.stringify(delModel.moduleList);
        let params: any = {
          Input: [
            {
              Name: "model",
              Value: delModel
            }
          ]
        };
        //console.log(params);
        var res: any = await httpApi.DeleteSmartFormMainAsync(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          //that.propFormList.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          // currentPage*pagesize
          this.$emit("LoadGetformList");
          if (this.propFormList.length % this.pagesize == 1) {
            this.currentPage = this.propFormList.length / this.pagesize;
          }
        } else {
          this.$message.error("删除失败：" + res.ErrorMessage);
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
  }
  /** 模板列表预览 */
  previewUserForm(item: any) {
    var _this = this;
    _this.userFormPreviewDialogVisible = true;
    _this.currentPreviewForm = item; // _this.propFormList[index];
    this.$nextTick(() => {
      this.qrcodeinit();
    });
  }
  /**
   * 复制预览地址
   */
  copyUrl() {
    var _input = document.createElement("input"); // 直接构建input
    _input.value = this.currentPreviewForm.codeUrl; // 设置内容
    document.body.appendChild(_input); // 添加临时实例
    _input.select(); // 选择实例内容
    document.execCommand("Copy"); // 执行复制
    this.$message({
      message: "复制成功!",
      type: "success"
    });
    document.execCommand("Copy");
    document.body.removeChild(_input); // 删除临时实例
  }
}
